import React from 'react';

interface ConfirmModalProps {
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title,
  message,
  confirmLabel = 'Save',
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="settings-modal-overlay" onClick={onCancel}>
      <div className="settings-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="settings-modal-title">{title}</h3>
        <p className="settings-modal-message">{message}</p>
        <div className="settings-modal-actions">
          <button className="settings-btn settings-btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button className="settings-btn settings-btn-primary" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
